module.exports = __webpack_public_path__ + "assets/img/5_1268.0d614dd8.jpg";